import * as React from "react";
import { Editable } from "./editable";
import { request } from "../../../services/cpln";
import { useAppSelector } from "../../../store/hooks";
import { selectOrg } from "../../../store/contextSlice";
import { FileSystemType } from "./fileSystemType";

interface Props {
  /** If provided, locks the file system type to this value */
  lockedFileSystemType?: FileSystemType;
}
export const Spec: React.FC<Props> = ({ lockedFileSystemType }) => {
  const org = useAppSelector(selectOrg);

  const [customEncryptionAwsInstructions, setCustomEncryptionAwsInstructions] = React.useState<any>(null);
  React.useEffect(() => {
    fetchAwsInstructions();
  }, []);

  async function fetchAwsInstructions() {
    try {
      const { data } = await request({ url: `/org/${org}/volumeset/-instructions/encryption/aws` });
      setCustomEncryptionAwsInstructions(JSON.stringify(data.keyPolicyStatements, null, 2));
    } catch (e) {
      setCustomEncryptionAwsInstructions(null);
    }
  }

  return <Editable customEncAwsInstructions={customEncryptionAwsInstructions} lockedFileSystemType={lockedFileSystemType} />;
};
